import {ReactNode, useContext} from 'react';
import {HiddenBottomButtonContext} from '../../../common/context';

interface IProps {
  className?: string;
  children: ReactNode;
}

export default function BottomButtonWrapperV4({className, children}: IProps) {
  const isHidden = useContext(HiddenBottomButtonContext);
  return (
    <div
      className={cn(
        'w-full inset-x-0 fixed bottom-32 flex-center gap-x-16',
        'transition-transform duration-[250ms]',
        isHidden ? '!translate-y-[calc(100%+32px)]' : 'translate-y-0',
        className
      )}
    >
      {children}
    </div>
  );
}
